import Kfit from '../integrations/Kfit';

export const setOutletCashback = (id, params) =>
  Kfit.patch(
    `/v7/outlets/${id}/fave_payment_outlet_details/cashback_rate`,
    params
  );
